import { ReactNode } from 'react';

type PageProps = {
    children?: ReactNode;
};

export const Page = ({ children }: PageProps) => {
    return (
        <div className="page-layout page-content-gray">
            <div className="page-content page-content-gray bh-full p-6 mx-auto max-w-[1920px]">
                <main className="page-content-wrapper h-full">{children}</main>
            </div>
        </div>
    );
};
